import { createClient } from '@supabase/supabase-js';
import type { Database } from '@beyond-silence/types';

const isLocal = typeof window !== 'undefined' && window.location.hostname === 'localhost';

const supabaseUrl = isLocal
  ? 'https://dijxmgdwizzgyrulmjaw.supabase.co'
  : 'https://api.beyondsilence.fr';

const supabaseKey = 'sb_publishable_ryJRqLyZfR9NggZ6YuCd5A__kZNuqVS';

export const supabase = createClient<Database>(supabaseUrl, supabaseKey, {
  auth: { autoRefreshToken: true, persistSession: true, detectSessionInUrl: true },
});
